import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=65ecc2b2&scoped=true&"
import script from "./Home.vue?vue&type=script&setup=true&lang=js&"
export * from "./Home.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ecc2b2",
  null
  
)

export default component.exports